// Otulá — dodawanie do koszyka z wnętrza szuflady (cross-sell + drugi ręcznik).
// Działa z mechanizmem odświeżania koszyka w Horizon (CartLinesUpdateEvent + Section Rendering API).
import { CartLinesUpdateEvent } from '@shopify/events';

class OtulaCartAdd extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('change', this.#onVariantChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('change', this.#onVariantChange);
  }

  // Zmiana wariantu w karcie cross-sellu → aktualizacja ceny (i ceny przekreślonej)
  #onVariantChange = (event) => {
    const select = event.target.closest('[data-otula-variant-select]');
    if (!select) return;

    const option = select.selectedOptions[0];
    const item = select.closest('li');
    if (!option || !item) return;

    const current = item.querySelector('[data-otula-price-current]');
    const compare = item.querySelector('[data-otula-price-compare]');
    const button = item.querySelector('[data-otula-add]');

    if (current && option.dataset.price) current.textContent = option.dataset.price;
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    if (button) button.dataset.variantId = option.value;
  };

  #onClick = async (event) => {
    const button = event.target.closest('[data-otula-add]');
    if (!button || !this.contains(button)) return;
    event.preventDefault();

    const item = button.closest('li') || this;
    const select = item.querySelector('[data-otula-variant-select]');
    const variantId = select ? select.value : button.dataset.variantId;
    if (!variantId) return;

    const errorEl = this.querySelector('.otula-cart-error');
    if (errorEl) errorEl.hidden = true;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ merchandiseId: String(variantId), quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (data.status) throw new Error(data.description || data.message || 'Nie udało się dodać produktu');

      const cart = await fetch(`${Theme.routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((r) => r.json());

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          itemCount: cart.item_count,
          source: 'otula-cart-add',
          sections: data.sections,
          didError: false,
        },
      });
    } catch (error) {
      deferred.reject(error);
      if (errorEl) {
        errorEl.textContent = error.message;
        errorEl.hidden = false;
      }
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }
  };
}

if (!customElements.get('otula-cart-add')) {
  customElements.define('otula-cart-add', OtulaCartAdd);
}
